import { api } from './api';

/* Data-layer persistence for the web voice path (transcripts written into the */
/* same `messages` table the text chat uses, so voice turns replay on reload). */
/* Routed through the backend (api.messages.persistVoice, owner-checked) — no */
/* supabase-js in the web. */
interface VoiceRow {
  thread_id?: string;
  role?: string;
  transcript?: string;
  created_at?: string;
  [k: string]: unknown;
}

export async function persistVoiceMessages(rows: VoiceRow[]): Promise<void> {
  if (rows.length === 0) return;
  const threadId = rows[0]?.thread_id;
  if (!threadId) return;
  try {
    await api.messages.persistVoice.mutate({
      threadId,
      rows: rows.map((r) => ({ role: String(r.role ?? 'user'), transcript: String(r.transcript ?? ''), created_at: r.created_at as string | undefined })),
    });
  } catch (e) {
    console.warn('[voice] message persist failed', e);
  }
}

export async function touchThreadActivity(threadId: string): Promise<void> {
  /* Empty-rows persist just bumps last_message_at server-side. */
  try {
    await api.messages.persistVoice.mutate({ threadId, rows: [] });
  } catch {
    /* best-effort */
  }
}
